import React, { Component } from "react";
import { getPage } from "./templateUtils";

// Paper the true-size preview is measured against
const A4 = getPage("A4");

// Shows a rendered template at print size, scaled down to fit. The iframe keeps
// the template's own <style> out of the app; sandbox blocks scripts inside it.
class TemplatePreview extends Component {
  constructor(props) {
    super(props);
    this.state = { boxWidth: 0, contentHeight: 0 };
    this.box = React.createRef();
  }

  componentDidMount() {
    this.measure();
    window.addEventListener("resize", this.measure);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.measure);
  }

  measure = () => {
    if (this.box.current) {
      this.setState({ boxWidth: this.box.current.offsetWidth });
    }
  };

  onFrameLoad = (e) => {
    const doc = e.target.contentDocument;
    if (doc && doc.body) {
      // scrollHeight leaves out the body's margins, which clips a receipt's end
      const { marginTop, marginBottom } = e.target.contentWindow.getComputedStyle(doc.body);
      this.setState({
        contentHeight:
          doc.body.scrollHeight + parseFloat(marginTop) + parseFloat(marginBottom)
      });
    }
  };

  render() {
    const { html, size, maxHeight, trueSize } = this.props;
    const { boxWidth, contentHeight } = this.state;
    const page = getPage(size);
    const pageHeight = page.height || contentHeight || page.width;
    const limit = maxHeight || Infinity;

    // trueSize: every paper at one scale, so a receipt looks narrower than A4.
    // Otherwise each page is fitted to the box.
    let scale = 0;
    if (boxWidth) {
      scale = trueSize
        ? Math.min(boxWidth / A4.width, limit / A4.height, 1)
        : Math.min(boxWidth / page.width, limit / pageHeight);
    }
    const scaledHeight = Math.ceil(pageHeight * scale);

    return (
      <div
        className="pt-preview"
        ref={this.box}
        style={{ height: trueSize ? Math.min(limit, A4.height * scale) : scaledHeight }}
      >
        <iframe
          title="Template preview"
          sandbox="allow-same-origin"
          tabIndex={-1}
          scrolling="no"
          srcDoc={html}
          onLoad={this.onFrameLoad}
          style={{
            width: page.width,
            height: pageHeight,
            left: (boxWidth - page.width * scale) / 2,
            transform: `scale(${scale})`
          }}
        />
      </div>
    );
  }
}

export default TemplatePreview;
